'use no memo'

import { HStack, Text } from '@/components/Atoms'
import { Button } from '@repo/ui/components'
import { Table } from '@tanstack/react-table'
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

type PageControlsProps<TData> = {
  table: Table<TData>
  rowCount: number
  pageSize: number
}

export function PageControls<TData>(props: PageControlsProps<TData>) {
  const { t } = useTranslation('common')

  const pageSize = props.pageSize

  if (props.rowCount < pageSize) return

  const totalPages = Math.ceil(props.rowCount / pageSize)

  return (
    <HStack gap="xl">
      <HStack gap="sm">
        <Button
          variant="secondary"
          size="icon"
          onClick={() => props.table.firstPage()}
          disabled={!props.table.getCanPreviousPage()}
        >
          <ChevronsLeftIcon />
        </Button>
        <Button
          variant="secondary"
          size="icon"
          onClick={() => props.table.previousPage()}
          disabled={!props.table.getCanPreviousPage()}
        >
          <ChevronLeftIcon />
        </Button>

        <HStack gap="xs" className="mx-2">
          <Text className="tabular-nums">{props.table.getState().pagination.pageIndex + 1}</Text>
          <Text tone="muted">{t('pageControls.of', { count: totalPages })}</Text>
        </HStack>

        <Button
          variant="secondary"
          size="icon"
          onClick={() => props.table.nextPage()}
          disabled={!props.table.getCanNextPage()}
        >
          <ChevronRightIcon />
        </Button>
        <Button
          variant="secondary"
          size="icon"
          onClick={() => props.table.lastPage()}
          disabled={!props.table.getCanNextPage()}
        >
          <ChevronsRightIcon />
        </Button>
      </HStack>
    </HStack>
  )
}
